export default "__VITE_ASSET__DhObU0os__"